'use client'

import { Button, Typography } from '@mui/material'

// Types
import type { TextButtonProps } from '@/types/components/atoms/button/text'

const PrimaryButtonAtom = (props: TextButtonProps) => {
	// Props
	const { text, description, type, loading, size, color, disabled, startIcon, endIcon, onClick, href, component, sx } = props

	return (
		<Button
			variant="contained"
			type={type}
			loading={loading}
			size={size}
			color={color}
			disabled={!!disabled}
			startIcon={startIcon}
			endIcon={endIcon}
			loadingPosition={!!startIcon ? 'end' : !!endIcon ? 'start' : 'center'}
			disableElevation
			onClick={onClick}
			href={href}
			component={component}
			sx={{
				p: 2,
				...(size === 'small' && { p: 1.25 }),
				...(size === 'medium' && { p: 1.5 }),
				fontSize: 16,
				fontWeight: 600,
				lineHeight: 1.5,
				textTransform: 'inherit',
				borderRadius: 1,
				...(description && {
					flexWrap: 'wrap',
					py: 1
				}),
				...(!color ? { color: '#fff', bgcolor: 'text.primary' } : color === 'inherit' ? { color: 'grey.900', bgcolor: 'grey.100' } : {}),
				'& .MuiListItemIcon-root': {
					minWidth: 24,
					mr: 1
				},
				'& .MuiSvgIcon-root': {
					fontSize: 24,
					...(!color && { color: '#fff' })
				},
				'&.Mui-disabled .MuiSvgIcon-root': { ...(!color && { color: 'action.disabled' }) },
				...sx
			}}
		>
			<Typography
				component="span"
				sx={{
					display: '-webkit-box',
					fontSize: 16,
					fontWeight: 600,
					lineHeight: 1.5,
					WebkitLineClamp: 3,
					WebkitBoxOrient: 'vertical',
					textOverflow: 'ellipsis',
					overflow: 'hidden',
					...(description && { width: 1, textAlign: 'center' })
				}}
			>
				{text}
			</Typography>

			{description && (
				<Typography
					component="div"
					sx={{
						display: '-webkit-box',
						width: 1,
						mt: 0.5,
						fontSize: 12,
						fontWeight: 500,
						lineHeight: 1,
						color: 'grey.800',
						WebkitLineClamp: 2,
						WebkitBoxOrient: 'vertical',
						textOverflow: 'ellipsis',
						overflow: 'hidden'
					}}
				>
					{description}
				</Typography>
			)}
		</Button>
	)
}

export default PrimaryButtonAtom
